// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1UWl0","info":"UpdateTermsInfo_info__lA_-2"};